module.exports = "<canvas #canvas id=\"confetti\"></canvas>\n"